import { render, staticRenderFns } from "./KeyPhone.vue?vue&type=template&id=fdb0809c&scoped=true&"
import script from "./KeyPhone.vue?vue&type=script&lang=js&"
export * from "./KeyPhone.vue?vue&type=script&lang=js&"
import style0 from "./KeyPhone.vue?vue&type=style&index=0&id=fdb0809c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb0809c",
  null
  
)

export default component.exports